import styles from "./index.module.css";
import Table from "shared/Table";

export default function ({ record }) {
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h3 className={styles.headerText}>Items</h3>
      </header>

      <Table>
        <thead>
          <tr>
            <th>Title</th>
            <th>SKU</th>
            <th>Quantity</th>
          </tr>
        </thead>
        <tbody>
          {record.items.map((r, i) => (
            <tr key={i}>
              <td>{r.title}</td>
              <td>{r.SKU}</td>
              <td>{r.quantity}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
